import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_carrierservices_grid_ComponentContextService } from './FootprintManager.carrierservices_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Carriers_carrierservicetypes_excl_carrier_dd_singleComponent } from './Carriers.carrierservicetypes_excl_carrier_dd_single.component'


interface IFootprintManager_carrierservices_gridComponentEntity {
  CarrierId?: number, ServiceTypeId?: number, Name?: string, Service_Type?: string, ServiceClass?: string, ServiceGroup?: string, ServiceMode?: string, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, ServiceType?: { Name?: string, ShortName?: string }}

interface IFootprintManager_carrierservices_gridComponentInParams {
  carrierId: number}


class FootprintManager_carrierservices_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_carrierservices_gridComponent;
  entity: IFootprintManager_carrierservices_gridComponentEntity;


  options: { on_instructions_clicked: ButtonModel } = {
    on_instructions_clicked: new ButtonModel('on_instructions_clicked', new ButtonStyles(null, null), false, false, false, 'Instructions', '', null)

  }

 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    servicetype_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    service_mode_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    service_type_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    service_group_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    service_class_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    servicetype_name: null,
    service_mode: null,
    service_type: null,
    service_group: null,
    service_class: null,
  }

  get $fields_servicetype_name_selector_inParams_carrierId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $grid.inParams.carrierId;
    
    return expr;
  }


  constructor(
    grid: FootprintManager_carrierservices_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_carrierservices_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.servicetype_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.servicetype_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['servicetype_name_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.service_mode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.service_mode,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['service_mode_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.service_type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.service_type,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['service_type_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.service_group = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.service_group,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['service_group_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.service_class = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.service_class,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['service_class_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_carrierservices_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.CarrierId,this.entity.ServiceTypeId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_carrierservices_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_new_row();
    }

    this.rowId = [this.entity.CarrierId,this.entity.ServiceTypeId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'CarrierId',this.entity.CarrierId);
    set($resultKey, 'ServiceTypeId',this.entity.ServiceTypeId);
    const inParams = {
      $keys:[$resultKey],
      carrierId:  $grid.inParams.carrierId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.Carriers.ds_carrierservices_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_carrierservices_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.servicetype_name.displayControl as TextModel).text = $row.entity.ServiceType?.Name;
    (this.cells.servicetype_name.editControl as SelectBoxModel).reset($row.entity.ServiceTypeId);
    (this.cells.service_mode.displayControl as TextModel).text = $row.entity.ServiceMode;
    (this.cells.service_mode.editControl as TextBoxModel).reset($row.entity.ServiceMode);
    (this.cells.service_type.displayControl as TextModel).text = $row.entity.Service_Type;
    (this.cells.service_type.editControl as TextBoxModel).reset($row.entity.Service_Type);
    (this.cells.service_group.displayControl as TextModel).text = $row.entity.ServiceGroup;
    (this.cells.service_group.editControl as TextBoxModel).reset($row.entity.ServiceGroup);
    (this.cells.service_class.displayControl as TextModel).text = $row.entity.ServiceClass;
    (this.cells.service_class.editControl as TextBoxModel).reset($row.entity.ServiceClass);

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_init_new_row(event = null) {
    return this.on_init_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_new_rowInternal(
    $row: FootprintManager_carrierservices_gridComponentRowModel,
  $grid: FootprintManager_carrierservices_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const carrierId = $grid.inParams.carrierId
  
  
  $row.entity = {
      CarrierId: carrierId
  };
  
  }
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: FootprintManager_carrierservices_gridComponentRowModel,
  $grid: FootprintManager_carrierservices_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $row.cells.servicetype_name.editControl.value
  );
  
  if (allRequiredFieldHaveValue === false) {
      $shell.Carriers.openErrorDialog('Save', 'Missing Required fields');
      throw new Error('Missing Required fields'); // to prevent displayMode 
  } else {
  
      try {
          const payload = {
  
              "CarrierId": $row.entity.CarrierId,
              "ServiceTypeId": $row.cells.servicetype_name.editControl.value,
              "Name": ' ',
              "ServiceMode": $row.cells.service_mode.editControl.value,
              "Service_Type": $row.cells.service_type.editControl.value,
              "ServiceGroup": $row.cells.service_group.editControl.value,
              "ServiceClass": $row.cells.service_class.editControl.value
  
          };
          await $flows.Utilities.crud_create_flow({ entitySet: 'CarrierServices', entity: payload });
  
          $grid.refresh();
  
      }
      catch (error) {
          $shell.Carriers.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  }
  
  
  
  
  
  
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_carrierservices_gridComponentRowModel,
  $grid: FootprintManager_carrierservices_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Construct payload with any values that have changed
  const payload : any = {};
  
  // General Properties
  if ($row.cells.servicetype_name.editControl.isChanged) 
  {
      payload.ServiceTypeId = $row.cells.servicetype_name.editControl.value;
  }
  if ($row.cells.service_mode.editControl.isChanged) 
  {
      payload.ServiceMode = $row.cells.service_mode.editControl.value;
  }
  if ($row.cells.service_type.editControl.isChanged) 
  {
      payload.Service_Type = $row.cells.service_type.editControl.value;
  }
  if ($row.cells.service_group.editControl.isChanged) 
  {
      payload.ServiceGroup = $row.cells.service_group.editControl.value;
  }
  if ($row.cells.service_class.editControl.isChanged) 
  {
      payload.ServiceClass = $row.cells.service_class.editControl.value;
  }
  
  
  
  if (!$utils.isDefined(payload)) { return; }
  
  // Make API call
  try 
  {
      (await $flows.Utilities.crud_update_dual_pk_flow({
          entitySet: 'CarrierServices',
          entity: payload,
          pk1String: 'CarrierId',
          pk1: $row.entity.CarrierId,
          pk2String: 'ServiceTypeId',
          pk2: $row.entity.ServiceTypeId
      }));
      
      await $grid.refresh();
  
      
  }
  catch (error)
  {
      $shell.DockAppointments.showErrorDetails('Save', 'Error on save.', error);
      throw error; // To prevent display mode
  }
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_carrierservices_gridComponentRowModel,
  $grid: FootprintManager_carrierservices_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($row.isNew) {
      $row.cells.servicetype_name.editControl.readOnly = false;
  }
  else {
  
      $row.cells.servicetype_name.editControl.readOnly = true;
  }
  }
  on_row_instructions_clicked(event = null) {
    return this.on_row_instructions_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_instructions_clickedInternal(
    $row: FootprintManager_carrierservices_gridComponentRowModel,
  $grid: FootprintManager_carrierservices_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  await $shell.FootprintManager.openinstructions_gridDialog({
      entityName: 'CarrierService',
      entityKey1: $row.entity.CarrierId,
      entityKey2: $row.entity.ServiceTypeId,
      enabled: true
  })
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Carriers_carrierservicetypes_excl_carrier_dd_singleComponent),
  ],
  selector: 'FootprintManager-carrierservices_grid',
  templateUrl: './FootprintManager.carrierservices_grid.component.html'
})
export class FootprintManager_carrierservices_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_carrierservices_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_carrierservices_gridComponentInParams = { carrierId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     servicetype_name: new GridHeaderModel(new HeaderStyles(null, null), 'servicetype_name', 'Name', false, false, null, false),       service_mode: new GridHeaderModel(new HeaderStyles(null, null), 'service_mode', 'Service mode', false, false, null, false),       service_type: new GridHeaderModel(new HeaderStyles(null, null), 'service_type', 'Service type', false, false, null, false),       service_group: new GridHeaderModel(new HeaderStyles(null, null), 'service_group', 'Service group', false, false, null, false),       service_class: new GridHeaderModel(new HeaderStyles(null, null), 'service_class', 'Service class', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_carrierservices_gridComponentRowModel[] = [];

  @Input('carrierId') set $inParams_carrierId(value: any) {
    this.inParams['carrierId'] = value;
  }
  get $inParams_carrierId(): any {
    return this.inParams['carrierId'] ;
  }

  topToolbar = {
      on_delete: new ToolModel(new ButtonModel('on_delete', new ButtonStyles(null, null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_carrierservices_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Carrier services';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.carrierId)) {
        this.$missingRequiredInParams.push('carrierId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      carrierId:  $grid.inParams.carrierId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.Carriers.ds_carrierservices_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_carrierservices_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_carrierservices_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_carrierservices_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  async addRow(entity?: IFootprintManager_carrierservices_gridComponentEntity) {
    const row = new FootprintManager_carrierservices_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_carrierservices_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRowsCount = $grid.selectedRows.length;
  
  if (selectedRowsCount > 0) {
      $grid.topToolbar.on_delete.control.readOnly = false;
  }
  else{
      $grid.topToolbar.on_delete.control.readOnly = true;
  }
  
  
  
  }
  on_delete(event = null) {
    return this.on_deleteInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_deleteInternal(
    $grid: FootprintManager_carrierservices_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.Carriers.openErrorDialog('Carrier Service Delete Error', 'No carrier service selected.');
      return;
  } else {
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
          const flowParams = {
              carrierId: row.entity.CarrierId,
              serviceTypeId: row.entity.ServiceTypeId
          };
          const result = await $flows.Carriers.is_carrierservice_deletable_flow(flowParams);
          const reason = result.reason;
          if ($utils.isDefined(reason)) {
              failures.push(row);
              errors.push(`Carrier Service ${row.entity.ServiceType.Name} - ${reason}`);
          } else {
              candidates.push(row);
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Delete Carrier Service errors';
          const errorMessage = `Carrier Service(s) ${failures.map(c => c.entity.ServiceType.Name).join(',')} cannot be deleted`;
          const errorList = errors;
          await $shell.Carriers.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Carrier Service(s) ${candidates.map(c => c.entity.ServiceType.Name).join(',')} - Once deleted, the Carrier Service(s) cannot be restored.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some Carrier Service(s) cannot be deleted';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.Carriers.openConfirmationDialog(title, message);
          } else {
              const title = 'Delete the following Carrier Service(s)';
              const message = confirmCandidates;
              confirm = await $shell.Carriers.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const processSuccess = [];
              const processFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      const flowParams = {
                          carrierId: candidate.entity.CarrierId,
                          serviceTypeId: candidate.entity.ServiceTypeId
                      }
                      const result = await $flows.Carriers.delete_carrierservice_flow(flowParams);
  
                      processSuccess.push(candidate);
                  } catch (error) {
                      processFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Carrier Service ${candidate.entity.ServiceType.Name} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (processSuccess.length === candidates.length) {
                  const title = 'All Carrier Service(s) deleted';
                  const message = `Carrier Service(s) ${processSuccess.map(c => c.entity.ServiceType.Name).join(',')} deleted`;
                  await $shell.Carriers.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (processFailures.length === candidates.length) {
                      const title = 'All Carrier Service(s) failed to delete';
                      const message = `Carrier Service(s) ${processFailures.map(c => c.entity.ServiceType.Name).join(',')} could not be deleted`;
                      await $shell.Carriers.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some Carrier Service could not be deleted';
                      const deleted = `Carrier Service(s) ${processSuccess.map(c => c.entity.ServiceType.Name).join(',')} were deleted.`;
                      const errors = `The following Carrier Service(s) could not be deleted: ${processFailures.map(c => c.entity.ServiceType.Name).join(',')}`;
                      const message = `${deleted} \r\n\r\n${errors}`;
                      await $shell.Carriers.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_carrierservices_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_carrierservices_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.canEdit = true;
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
